// package: openbank.v1.admin
// file: brank.as/gunk/admin/all.proto

var brank_as_gunk_admin_all_pb = require("./all_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var InternalAdmin = (function () {
  function InternalAdmin() {}
  InternalAdmin.serviceName = "openbank.v1.admin.InternalAdmin";
  return InternalAdmin;
}());

InternalAdmin.GetBanks = {
  methodName: "GetBanks",
  service: InternalAdmin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetBanksRequest,
  responseType: brank_as_gunk_admin_all_pb.GetBanksResponse
};

InternalAdmin.SetBankStatus = {
  methodName: "SetBankStatus",
  service: InternalAdmin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.SetBankStatusRequest,
  responseType: brank_as_gunk_admin_all_pb.SetBankStatusResponse
};

exports.InternalAdmin = InternalAdmin;

function InternalAdminClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InternalAdminClient.prototype.getBanks = function getBanks(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(InternalAdmin.GetBanks, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalAdminClient.prototype.setBankStatus = function setBankStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(InternalAdmin.SetBankStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.InternalAdminClient = InternalAdminClient;

var Admin = (function () {
  function Admin() {}
  Admin.serviceName = "openbank.v1.admin.Admin";
  return Admin;
}());

Admin.UpdateCompanyInformation = {
  methodName: "UpdateCompanyInformation",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.UpdateCompanyInformationRequest,
  responseType: brank_as_gunk_admin_all_pb.UpdateCompanyInformationResponse
};

Admin.GetClients = {
  methodName: "GetClients",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetClientDetailsRequest,
  responseType: brank_as_gunk_admin_all_pb.GetClientDetailsResponse
};

Admin.GetClientInfo = {
  methodName: "GetClientInfo",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetClientInfoRequest,
  responseType: brank_as_gunk_admin_all_pb.ClientDetail
};

Admin.GetClientDocuments = {
  methodName: "GetClientDocuments",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetClientDocumentsRequest,
  responseType: brank_as_gunk_admin_all_pb.GetClientDocumentsResponse
};

Admin.GetBankSecret = {
  methodName: "GetBankSecret",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetBankSecretRequest,
  responseType: brank_as_gunk_admin_all_pb.GetBankSecretResponse
};

Admin.GetBankSecrets = {
  methodName: "GetBankSecrets",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetBankSecretsRequest,
  responseType: brank_as_gunk_admin_all_pb.GetBankSecretsResponse
};

Admin.DeleteBankSecret = {
  methodName: "DeleteBankSecret",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.DeleteBankSecretRequest,
  responseType: brank_as_gunk_admin_all_pb.DeleteBankSecretResponse
};

Admin.CreateBankSecret = {
  methodName: "CreateBankSecret",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.CreateBankSecretRequest,
  responseType: brank_as_gunk_admin_all_pb.CreateBankSecretResponse
};

Admin.UpdateOrgIsLive = {
  methodName: "UpdateOrgIsLive",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.UpdateOrgIsLiveRequest,
  responseType: brank_as_gunk_admin_all_pb.UpdateOrgIsLiveResponse
};

Admin.GetTransactions = {
  methodName: "GetTransactions",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetTransactionsRequest,
  responseType: brank_as_gunk_admin_all_pb.GetTransactionsResponse
};

Admin.DownloadTransactions = {
  methodName: "DownloadTransactions",
  service: Admin,
  requestStream: false,
  responseStream: true,
  requestType: brank_as_gunk_admin_all_pb.DownloadTransactionsRequest,
  responseType: brank_as_gunk_admin_all_pb.DownloadTransactionsResponse
};

Admin.IsUserAuthorized = {
  methodName: "IsUserAuthorized",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.IsUserAuthorizedRequest,
  responseType: brank_as_gunk_admin_all_pb.IsUserAuthorizedResponse
};

Admin.UpdateKYCStatus = {
  methodName: "UpdateKYCStatus",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.UpdateKYCStatusRequest,
  responseType: brank_as_gunk_admin_all_pb.UpdateKYCStatusResponse
};

Admin.RejectKYCApplication = {
  methodName: "RejectKYCApplication",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.RejectKYCApplicationRequest,
  responseType: brank_as_gunk_admin_all_pb.RejectKYCApplicationResponse
};

Admin.UpsertPayerFICredentials = {
  methodName: "UpsertPayerFICredentials",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.UpsertPayerFICredentialsRequest,
  responseType: brank_as_gunk_admin_all_pb.UpsertPayerFICredentialsResponse
};

Admin.GetBusinessOwner = {
  methodName: "GetBusinessOwner",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetBusinessOwnerInformationRequest,
  responseType: brank_as_gunk_admin_all_pb.BusinessOwner
};

Admin.UpdateFIService = {
  methodName: "UpdateFIService",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.UpdateFIServiceRequest,
  responseType: brank_as_gunk_admin_all_pb.UpdateFIServiceResponse
};

Admin.ReviewKYCDocument = {
  methodName: "ReviewKYCDocument",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.KYCDocumentReviewRequest,
  responseType: brank_as_gunk_admin_all_pb.KYCDocumentReviewResponse
};

Admin.GetSupportingDocuments = {
  methodName: "GetSupportingDocuments",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetSupportingDocumentsRequest,
  responseType: brank_as_gunk_admin_all_pb.GetSupportingDocumentsResponse
};

Admin.GetFinancePIC = {
  methodName: "GetFinancePIC",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetFinancePICRequest,
  responseType: brank_as_gunk_admin_all_pb.GetFinancePICResponse
};

Admin.GetPayerFICredential = {
  methodName: "GetPayerFICredential",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetPayerFICredentialsRequest,
  responseType: brank_as_gunk_admin_all_pb.GetPayerFICredentialsResponse
};

Admin.GetMerchantFICredential = {
  methodName: "GetMerchantFICredential",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetMerchantFICredentialsRequest,
  responseType: brank_as_gunk_admin_all_pb.GetMerchantFICredentialsResponse
};

Admin.UpdateBusinessOwner = {
  methodName: "UpdateBusinessOwner",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.UpdateBusinessOwnerInformationRequest,
  responseType: brank_as_gunk_admin_all_pb.UpdateBusinessOwnerInformationResponse
};

Admin.SubmitFinancePIC = {
  methodName: "SubmitFinancePIC",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.SubmitFinancePICRequest,
  responseType: brank_as_gunk_admin_all_pb.SubmitFinancePICResponse
};

Admin.RemoveFinancePIC = {
  methodName: "RemoveFinancePIC",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.RemoveFinancePICRequest,
  responseType: brank_as_gunk_admin_all_pb.RemoveFinancePICResponse
};

Admin.SubmitSupportingDocuments = {
  methodName: "SubmitSupportingDocuments",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.SubmitSupportingDocumentsRequest,
  responseType: brank_as_gunk_admin_all_pb.SubmitSupportingDocumentsResponse
};

Admin.RemoveClientDocuments = {
  methodName: "RemoveClientDocuments",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.RemoveClientDocumentsRequest,
  responseType: brank_as_gunk_admin_all_pb.RemoveClientDocumentsResponse
};

Admin.GetPermataCompanyInfo = {
  methodName: "GetPermataCompanyInfo",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetPermataCompanyInfoRequest,
  responseType: brank_as_gunk_admin_all_pb.GetPermataCompanyInfoResponse
};

Admin.GetPermataDocuments = {
  methodName: "GetPermataDocuments",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetPermataDocumentsRequest,
  responseType: brank_as_gunk_admin_all_pb.GetPermataDocumentsResponse
};

Admin.GetUserActivityLogs = {
  methodName: "GetUserActivityLogs",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetUserActivityLogRequest,
  responseType: brank_as_gunk_admin_all_pb.GetUserActivityLogResponse
};

Admin.ListBusiness = {
  methodName: "ListBusiness",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.ListBusinessRequest,
  responseType: brank_as_gunk_admin_all_pb.ListBusinessResponse
};

Admin.ListUsers = {
  methodName: "ListUsers",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.ListUsersRequest,
  responseType: brank_as_gunk_admin_all_pb.ListUsersResponse
};

Admin.RemoveUser = {
  methodName: "RemoveUser",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.RemoveUserRequest,
  responseType: brank_as_gunk_admin_all_pb.RemoveUserResponse
};

Admin.GetIntegrations = {
  methodName: "GetIntegrations",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.GetIntegrationsRequest,
  responseType: brank_as_gunk_admin_all_pb.GetIntegrationsResponse
};

Admin.UpdateIntegrationStatus = {
  methodName: "UpdateIntegrationStatus",
  service: Admin,
  requestStream: false,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.UpdateIntegrationStatusRequest,
  responseType: brank_as_gunk_admin_all_pb.EmptyResponse
};

Admin.UploadFile = {
  methodName: "UploadFile",
  service: Admin,
  requestStream: true,
  responseStream: false,
  requestType: brank_as_gunk_admin_all_pb.UploadFileRequest,
  responseType: brank_as_gunk_admin_all_pb.UploadFileResponse
};

exports.Admin = Admin;

function AdminClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

AdminClient.prototype.updateCompanyInformation = function updateCompanyInformation(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.UpdateCompanyInformation, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getClients = function getClients(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetClients, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getClientInfo = function getClientInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetClientInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getClientDocuments = function getClientDocuments(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetClientDocuments, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getBankSecret = function getBankSecret(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetBankSecret, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getBankSecrets = function getBankSecrets(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetBankSecrets, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.deleteBankSecret = function deleteBankSecret(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.DeleteBankSecret, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.createBankSecret = function createBankSecret(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.CreateBankSecret, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.updateOrgIsLive = function updateOrgIsLive(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.UpdateOrgIsLive, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getTransactions = function getTransactions(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetTransactions, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.downloadTransactions = function downloadTransactions(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(Admin.DownloadTransactions, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

AdminClient.prototype.isUserAuthorized = function isUserAuthorized(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.IsUserAuthorized, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.updateKYCStatus = function updateKYCStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.UpdateKYCStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.rejectKYCApplication = function rejectKYCApplication(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.RejectKYCApplication, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.upsertPayerFICredentials = function upsertPayerFICredentials(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.UpsertPayerFICredentials, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getBusinessOwner = function getBusinessOwner(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetBusinessOwner, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.updateFIService = function updateFIService(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.UpdateFIService, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.reviewKYCDocument = function reviewKYCDocument(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.ReviewKYCDocument, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getSupportingDocuments = function getSupportingDocuments(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetSupportingDocuments, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getFinancePIC = function getFinancePIC(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetFinancePIC, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getPayerFICredential = function getPayerFICredential(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetPayerFICredential, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getMerchantFICredential = function getMerchantFICredential(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetMerchantFICredential, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.updateBusinessOwner = function updateBusinessOwner(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.UpdateBusinessOwner, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.submitFinancePIC = function submitFinancePIC(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.SubmitFinancePIC, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.removeFinancePIC = function removeFinancePIC(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.RemoveFinancePIC, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.submitSupportingDocuments = function submitSupportingDocuments(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.SubmitSupportingDocuments, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.removeClientDocuments = function removeClientDocuments(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.RemoveClientDocuments, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getPermataCompanyInfo = function getPermataCompanyInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetPermataCompanyInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getPermataDocuments = function getPermataDocuments(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetPermataDocuments, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getUserActivityLogs = function getUserActivityLogs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetUserActivityLogs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.listBusiness = function listBusiness(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.ListBusiness, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.listUsers = function listUsers(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.ListUsers, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.removeUser = function removeUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.RemoveUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.getIntegrations = function getIntegrations(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.GetIntegrations, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.updateIntegrationStatus = function updateIntegrationStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Admin.UpdateIntegrationStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AdminClient.prototype.uploadFile = function uploadFile(metadata) {
  var listeners = {
    end: [],
    status: []
  };
  var client = grpc.client(Admin.UploadFile, {
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport
  });
  client.onEnd(function (status, statusMessage, trailers) {
    listeners.status.forEach(function (handler) {
      handler({ code: status, details: statusMessage, metadata: trailers });
    });
    listeners.end.forEach(function (handler) {
      handler({ code: status, details: statusMessage, metadata: trailers });
    });
    listeners = null;
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    write: function (requestMessage) {
      if (!client.started) {
        client.start(metadata);
      }
      client.send(requestMessage);
      return this;
    },
    end: function () {
      client.finishSend();
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

exports.AdminClient = AdminClient;

